export default function _isTransformer(obj) {
  return obj != null && typeof obj['@@transducer/step'] === 'function';
}


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/ramda/es/internal/_isTransformer.js
// module id = 219
// module chunks = 2 3 4 5 6 7 8 10